module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-508.b743c04.woff2";